var styles = {"name":"styles_name__1RKZ5 bold mb1","category":"styles_category__3o9B1","avatar-container":"styles_avatar-container__2p20M mb2","avatarContainer":"styles_avatar-container__2p20M mb2"};

export default styles;
//# sourceMappingURL=styles.css.js.map
